var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuaotationIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 78,
    viewBox: "0 0 70 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3633_15829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1037 48.3781V53.8764C46.1037 55.6886 44.6347 57.1576 42.8225 57.1576H17.3337C15.5215 57.1576 14.0525 55.6886 14.0525 53.8764V19.8093C14.0525 17.9971 15.5215 16.5281 17.3337 16.5281H24.99V45.0968C24.99 46.9091 26.459 48.3781 28.2712 48.3781H46.1037Z",
    fill: "#4A3163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9475 18.6499V46.1906C55.9475 48.0028 54.4785 49.4718 52.6662 49.4718H27.1775C25.3653 49.4718 23.8962 48.0028 23.8962 46.1906V12.1235C23.8962 10.3113 25.3653 8.84229 27.1775 8.84229H46.4275L46.5369 8.95494L46.4275 9.06104V16.8671C46.4275 17.8517 47.2257 18.6499 48.2103 18.6499H55.7287L55.8414 18.5406L55.9475 18.6499Z",
    fill: "#573A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8414 18.5406L55.7287 18.65H48.2103C47.2257 18.65 46.4275 17.8517 46.4275 16.8671V9.06105L46.5369 8.95496L55.8414 18.5406Z",
    fill: "#4A3163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9079 32.159H29.387C28.7829 32.159 28.2932 31.6693 28.2932 31.0652C28.2932 30.4611 28.7829 29.9715 29.387 29.9715H49.9079C50.512 29.9715 51.0017 30.4611 51.0017 31.0652C51.0017 31.6693 50.512 32.159 49.9079 32.159ZM41.672 26.0405H29.387C28.7829 26.0405 28.2932 25.5509 28.2932 24.9468C28.2932 24.3427 28.7829 23.853 29.387 23.853H41.672C42.276 23.853 42.7657 24.3427 42.7657 24.9468C42.7657 25.5509 42.276 26.0405 41.672 26.0405ZM49.9079 38.7215H29.387C28.7829 38.7215 28.2932 38.2318 28.2932 37.6277C28.2932 37.0236 28.7829 36.534 29.387 36.534H49.9079C50.512 36.534 51.0017 37.0236 51.0017 37.6277C51.0017 38.2318 50.512 38.7215 49.9079 38.7215Z",
    fill: "#BE9FE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3633_15829",
    x: -7,
    y: -3,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3633_15829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3633_15829"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3633_15829",
    result: "effect2_dropShadow_3633_15829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3633_15829",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuaotationIco);
export default __webpack_public_path__ + "static/media/quaotationIco.43d373862051a412b6054d1af3b2475c.svg";
export { ForwardRef as ReactComponent };